import { datiIntermediario, datiConsenso } from './sezioni/sezioniDichiarazioni';

export const dichiarazioni = {
  datiIntermediario: datiIntermediario,
  datiConsenso: datiConsenso,
};